
import React, { useEffect, useRef, useState } from 'react'
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setDataLayout } from "../../data/redux/themeSettingSlice";
import ImageWithBasePath from "../imageWithBasePath";
import { setMobileSidebar, toggleMiniSidebar, } from "../../data/redux/sidebarSlice";
import { all_routes } from "../../../feature-module/router/all_routes";
import { HorizontalSidebarData } from '../../data/json/horizontalSidebar'
import { logOut } from '../../data/redux/auth/authSlice';
import { logout, verifyActiveSession } from '../../data/redux/auth/authAction';
import { AppDispatch } from '../../data/redux/store';
import ChangePasswordModal from '../../../feature-module/pages/profile/passwordUpdate';
import { getUserById } from '../../data/redux/user/userAction';
import { getEmployeeByUserId } from '../../data/redux/employee/employeeAction';
import { fetchEmployeeNotifications, markNotificationAsRead } from '../../data/redux/notification/employeeNotification/employeeNotificationActions';
import { setSearchQuery } from '../../data/redux/gloabalSearch/sidebarSearchSlice';
import { changeUserCompanyPreference, fetchActiveCompanyForUser, fetchCompanyDetails, fetchCompanyDetailsById, updateCompanyDetails } from '../../data/redux/company/companyDetailsActions';
import { useIdleLogout } from './useIdleLogout';
import { Select } from 'antd';
const Header = () => {
	const routes = all_routes;
	const dispatch = useDispatch<AppDispatch>();
	const dataLayout = useSelector((state: any) => state.themeSetting.dataLayout);
	const Location = useLocation();
	const { user } = useSelector((state: any) => state.auth);
	const { users } = useSelector((state: any) => state.user);
	const [subOpen, setSubopen] = useState<any>("");
	const [subsidebar, setSubsidebar] = useState("");
	const [timeLeft, setTimeLeft] = useState('');
	const navigate = useNavigate();
	const userInformation = users?.[0]?.data;
	const { employeesbyUser } = useSelector((state: any) => state.employee);
	const { notifications } = useSelector((state: any) => state.notification.employeeNotification);
	const { companyDetails = [] } = useSelector((state: any) => state.companyDetails || []);
	const { activeCompany } = useSelector((state: any) => state.companyDetails);
	const [selectedCompanyId, setSelectedCompanyId] = useState<string | null>(null);
	const currentEmployeeId = employeesbyUser?.employeeId;
	const inputRef = useRef<any>(null);

	useEffect(() => {
		if (activeCompany?.company_detail_id) {
			setSelectedCompanyId(activeCompany.company_detail_id.toString());
			dispatch(fetchCompanyDetailsById(activeCompany.company_detail_id));
		}
	}, [activeCompany?.company_detail_id, dispatch]);

	const handleCompanyChange = async (companyId: string) => {
		setSelectedCompanyId(companyId);
		const formData = new FormData();
		formData.append('status', 'active');

		const resultAction = await dispatch(changeUserCompanyPreference({
			userId: user?.UserId,
			company_details_id: Number(companyId),
		}));
		if (changeUserCompanyPreference.fulfilled.match(resultAction)) {
			// Step 2: After preference saved, refetch updated activeCompany
			if (user?.UserId) {
				await dispatch(fetchActiveCompanyForUser(user.UserId));
			}
			// Step 3: Optionally fetch company details again
			await dispatch(fetchCompanyDetailsById(Number(companyId)));
			await dispatch(fetchCompanyDetails());
			window.location.reload();
		} else {
			console.error("Failed to change company preference");
		}
	};
	useEffect(() => {
		if (user?.UserId) {
			dispatch(fetchActiveCompanyForUser(user.UserId));
		}
	}, [user?.UserId, dispatch]);



	const handleMarkAllRead = async () => {
		if (!notifications?.data?.length || !currentEmployeeId) return;

		const markReadPromises = notifications.data
			.filter((notif: any) => !notif.isRead)
			.map((notif: any) =>
				dispatch(
					markNotificationAsRead({
						notificationId: notif.notification_id,
						employeeId: currentEmployeeId,
					})
				)
			);
		await Promise.all(markReadPromises);
		dispatch(fetchEmployeeNotifications({ employeeId: currentEmployeeId }));
	};

	useEffect(() => {
		if (user?.UserId) {
			dispatch(getEmployeeByUserId({ userId: user?.UserId }));
		}
	}, [dispatch, user?.UserId]);

	useEffect(() => {
		dispatch(fetchCompanyDetails())
	}, [dispatch])

	useEffect(() => {
		if (currentEmployeeId) {
			dispatch(fetchEmployeeNotifications({ employeeId: currentEmployeeId }));
		}
	}, [dispatch, currentEmployeeId]);

	useEffect(() => {
		if (!user?.checkRenewStatus || !user?.end_date) return;

		const endDate = new Date(user.end_date + 'T23:59:59');
		const gracePeriodEnd = new Date(endDate);
		gracePeriodEnd.setDate(gracePeriodEnd.getDate() + 7);

		const subscriptionWarningStart = new Date(endDate);
		subscriptionWarningStart.setDate(subscriptionWarningStart.getDate() - 7);

		const interval = setInterval(() => {
			const now = new Date();

			if (now < subscriptionWarningStart) {
				// More than 7 days left — don't show anything
				setTimeLeft('');
				return;
			}

			if (now >= subscriptionWarningStart && now < endDate) {
				// Countdown to subscription expiry
				const diff = endDate.getTime() - now.getTime();
				const days = Math.floor(diff / (1000 * 60 * 60 * 24));
				const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
				const minutes = Math.floor((diff / (1000 * 60)) % 60);
				const seconds = Math.floor((diff / 1000) % 60);
				setTimeLeft(`Your subscription expires in ${days}d ${hours}h ${minutes}m ${seconds}s`);
				return;
			}
			if (now >= endDate && now < gracePeriodEnd) {
				// Countdown to grace period expiry
				const diff = gracePeriodEnd.getTime() - now.getTime();
				const days = Math.floor(diff / (1000 * 60 * 60 * 24));
				const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
				const minutes = Math.floor((diff / (1000 * 60)) % 60);
				const seconds = Math.floor((diff / 1000) % 60);
				setTimeLeft(`Your grace period ends in ${days}d ${hours}h ${minutes}m ${seconds}s`);
				return;
			}
			setTimeLeft('Expired');
			clearInterval(interval);
		}, 1000);

		return () => clearInterval(interval);
	}, [user?.end_date, user?.checkRenewStatus]);

	useEffect(() => {
		if (!userInformation) {
			dispatch(getUserById(user?.UserId));
		}
	}, [userInformation, dispatch, user?.UserId]);

	useEffect(() => {
		const checkSession = async () => {
			const session_id = localStorage.getItem('session_id');
			if (session_id) {
				const result = await dispatch(verifyActiveSession({ session_id }));
				if (verifyActiveSession.fulfilled.match(result)) {
				} else {
					handleLogout();
				}
			}
		};
		checkSession();
	}, []);


	const [isModalVisible, setIsModalVisible] = useState<boolean>(false);

	const showModal = () => {
		setIsModalVisible(true);
	};

	const handleCancel = () => {
		setIsModalVisible(false);
	};

	const toggleSidebar = (title: any) => {
		localStorage.setItem("menuOpened", title);
		if (title === subOpen) {
			setSubopen("");
		} else {
			setSubopen(title);
		}
	};

	const toggleSubsidebar = (subitem: any) => {
		if (subitem === subsidebar) {
			setSubsidebar("");
		} else {
			setSubsidebar(subitem);
		}
	};

	const mobileSidebar = useSelector(
		(state: any) => state.sidebarSlice.mobileSidebar
	);
	const toggleMobileSidebar = () => {
		dispatch(setMobileSidebar(!mobileSidebar));
	};

	const handleToggleMiniSidebar = () => {
		if (dataLayout === "mini_layout") {
			dispatch(setDataLayout("default_layout"));
			localStorage.setItem("dataLayout", "default_layout");
		} else {
			dispatch(toggleMiniSidebar());
		}
	};

	const [isFullscreen, setIsFullscreen] = useState(false);
	const toggleFullscreen = () => {
		if (!isFullscreen) {
			if (document.documentElement.requestFullscreen) {
				document.documentElement.requestFullscreen().catch((err) => {
				});
				setIsFullscreen(true);
			}
		} else {
			if (document.exitFullscreen) {
				if (document.fullscreenElement) {
					document.exitFullscreen().catch((err) => {
					});
				}
				setIsFullscreen(false);
			}
		}
	};

	const handleLogout = async () => {
		try {
			dispatch(logOut())
			await dispatch(logout(user?.Email));
			navigate(routes.login);
		} catch (error) {
			console.error("Logout failed", error);
		}
	};

	const { isWarning, remainingSec } = useIdleLogout(handleLogout, 30 * 60 * 1000, 2 * 60 * 1000);

	// eslint-disable-next-line react-hooks/exhaustive-deps
	useEffect(() => {
		const checkSession = async () => {
			try {
				const response = await fetch(`${process.env.REACT_APP_AUTH_SERVICE_SERVER_BASE_URL}/auth/verify-session`, {
					method: 'GET',
					credentials: 'include',
				});
				if (response.status === 401 || response.status === 403) {
					dispatch(logOut());
					navigate('/login');
				}
			} catch (error) {
				console.error("Session check failed:", error);
				dispatch(logOut());
				navigate('/login');
			}
		};

		checkSession();
		const intervalId = setInterval(() => {
			checkSession();
		}, 600000);

		return () => clearInterval(intervalId);
	}, []);

	useEffect(() => {
		const handleKeyDown = (e: any) => {
			if ((e.ctrlKey || e.metaKey) && e.key === "/") {
				e.preventDefault();
				inputRef.current?.focus();
			}
		};

		window.addEventListener("keydown", handleKeyDown);

		return () => {
			window.removeEventListener("keydown", handleKeyDown);
		};
	}, []);


	return (
		<>
			{/* Header */}
			<div className="header">
				<div className="main-header">
					<div className="header-left">
						<Link to={routes.adminDashboard} className="logo">
							<ImageWithBasePath src="assets/img/hrmlogo24.svg" alt="Logo" />
						</Link>
						<Link to={routes.adminDashboard} className="dark-logo">
							<ImageWithBasePath src="assets/img/hrmlogo24.svg" alt="Logo" />
						</Link>
					</div>

					<Link id="mobile_btn" onClick={toggleMobileSidebar} className="mobile_btn" to="#sidebar">
						<span className="bar-icon">
							<span></span>
							<span></span>
							<span></span>
						</span>
					</Link>

					<div className="header-user">
						<div className="nav user-menu nav-list">
							<div className="me-auto d-flex align-items-center" id="header-search">
								<Link id="toggle_btn" to="#" onClick={handleToggleMiniSidebar} className="btn btn-menubar me-1">
									<i className="ti ti-arrow-bar-to-left"></i>
								</Link>
								<div className="input-group input-group-flat d-inline-flex me-1">
									<span className="input-icon-addon">
										<i className="ti ti-search"></i>
									</span>
									{/* <input type="text" className="form-control" ref={inputRef} onChange={(e) => dispatch(setSearchQuery(e.target.value))} placeholder="Search in hrmtree" /> */}
									<input
										type="text"
										className="form-control"
										ref={inputRef}
										onClick={() => window.dispatchEvent(new Event("open-ai-search"))}
										onChange={(e) => {
											dispatch(setSearchQuery(e.target.value));
											window.dispatchEvent(new Event("open-ai-search")); // auto-open while typing
										}}
										placeholder="Ask Leadchain AI"
									/>

									<span className="input-group-text">
										<kbd>CTRL + / </kbd>
									</span>
								</div>
								{/* <div className="dropdown crm-dropdown">
									<Link to="#" className="btn btn-menubar me-1" data-bs-toggle="dropdown">
										<i className="ti ti-layout-grid"></i>
									</Link>
									<div className="dropdown-menu dropdown-lg dropdown-menu-start">
										<div className="card mb-0 border-0 shadow-none">
											<div className="card-header">
												<h4>CRM</h4>
											</div>
											<div className="card-body pb-1">
												<div className="row">
													<div className="col-sm-6">
														<Link to={routes.contactList} className="d-flex align-items-center justify-content-between p-2 crm-link mb-3">
															<span className="d-flex align-items-center me-3">
																<i className="ti ti-user-shield text-default me-2"></i>Contacts
															</span>
															<i className="ti ti-arrow-right"></i>
														</Link>
														<Link to={routes.dealsGrid} className="d-flex align-items-center justify-content-between p-2 crm-link mb-3">
															<span className="d-flex align-items-center me-3">
																<i className="ti ti-heart-handshake text-default me-2"></i>Deals
															</span>
															<i className="ti ti-arrow-right"></i>
														</Link>
														<Link to={routes.pipeline} className="d-flex align-items-center justify-content-between p-2 crm-link mb-3">
															<span className="d-flex align-items-center me-3">
																<i className="ti ti-timeline-event-text text-default me-2"></i>Pipeline
															</span>
															<i className="ti ti-arrow-right"></i>
														</Link>
													</div>
													<div className="col-sm-6">
														<Link to={routes.companiesGrid} className="d-flex align-items-center justify-content-between p-2 crm-link mb-3">
															<span className="d-flex align-items-center me-3">
																<i className="ti ti-building text-default me-2"></i>Companies
															</span>
															<i className="ti ti-arrow-right"></i>
														</Link>
														<Link to={routes.leadsGrid} className="d-flex align-items-center justify-content-between p-2 crm-link mb-3">
															<span className="d-flex align-items-center me-3">
																<i className="ti ti-user-check text-default me-2"></i>Leads
															</span>
															<i className="ti ti-arrow-right"></i>
														</Link>
														<Link to={routes.activity} className="d-flex align-items-center justify-content-between p-2 crm-link mb-3">
															<span className="d-flex align-items-center me-3">
																<i className="ti ti-activity text-default me-2"></i>Activities
															</span>
															<i className="ti ti-arrow-right"></i>
														</Link>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div> */}
								{/* <Link to={routes.profilesettings} className="btn btn-menubar">
									<i className="ti ti-settings-cog"></i>
								</Link> */}
								{isWarning && (
									<span className="badge bg-danger ms-3" title="Auto-logout due to inactivity">
										Auto logout in {remainingSec}s
									</span>
								)}
								{user?.checkRenewStatus && (
									<p className="text-warning">
										{timeLeft}
									</p>
								)}
							</div>

							<div className="sidebar sidebar-horizontal" id="horizontal-single">
								<div className="sidebar-menu">
									<div className="main-menu">
										<ul className="nav-menu">
											<li className="menu-title">
												<span>Main</span>
											</li>
											{HorizontalSidebarData?.map((mainMenu, index) => (
												<React.Fragment key={`main-${index}`}>
													{mainMenu?.menu?.map((data, i) => (
														<li className="submenu" key={`menu-${i}`}>
															<Link to="#" className={`
														${data?.subMenus
																	?.map((link: any) => link?.route)
																	.includes(Location.pathname)
																	? "active"
																	: ""
																} ${subOpen === data.menuValue ? "subdrop" : ""}`} onClick={() => toggleSidebar(data.menuValue)}>
																<i className={`ti ti-${data.icon}`}></i>
																<span>{data.menuValue}</span>
																<span className="menu-arrow"></span>
															</Link>

															{/* First-level Submenus */}
															<ul style={{ display: subOpen === data.menuValue ? "block" : "none" }}>
																{data?.subMenus?.map((subMenu: any, j) => (
																	<li
																		key={`submenu-${j}`}
																		className={subMenu?.customSubmenuTwo ? "submenu" : ""}
																	>
																		<Link to={subMenu?.route || "#"} className={`${subMenu?.subMenusTwo
																			?.map((link: any) => link?.route)
																			.includes(Location.pathname) || subMenu?.route === Location.pathname
																			? "active"
																			: ""
																			} ${subsidebar === subMenu.menuValue ? "subdrop" : ""}`} onClick={() => toggleSubsidebar(subMenu.menuValue)}>
																			<span>{subMenu?.menuValue}</span>
																			{subMenu?.customSubmenuTwo && <span className="menu-arrow"></span>}
																		</Link>

																		{/* Check if `customSubmenuTwo` exists */}
																		{subMenu?.customSubmenuTwo && subMenu?.subMenusTwo && (
																			<ul style={{ display: subsidebar === subMenu.menuValue ? "block" : "none" }}>
																				{subMenu.subMenusTwo.map((subMenuTwo: any, k: number) => (
																					<li key={`submenu-two-${k}`}>
																						<Link className={subMenuTwo.route === Location.pathname ? 'active' : ''} to={subMenuTwo.route}>{subMenuTwo.menuValue}</Link>
																					</li>
																				))}
																			</ul>
																		)}
																	</li>
																))}
															</ul>
														</li>
													))}
												</React.Fragment>
											))}
										</ul>
									</div>
								</div>
							</div>
							<div className="d-flex align-items-center">
								<div className="me-2">
									<Select
										style={{ width: '250px' }}
										showSearch
										placeholder="Select Company"
										optionFilterProp="children"
										disabled={user?.role_name !== "Admin"}
										value={selectedCompanyId || undefined}
										onChange={handleCompanyChange}
										filterOption={(input: any, option: any) => {
											const text = typeof option?.children === 'string'
												? option.children
												: option?.children?.props?.children?.[0] || '';

											return text.toLowerCase().includes(input.toLowerCase());
										}}
									>
										{companyDetails.map((company: any) => (
											<Select.Option key={company.company_detail_id} value={company.company_detail_id.toString()}>
												<span>
													{company.company_name}{' '}
													{company.company_detail_id === activeCompany?.company_detail_id ? (
														<strong style={{ color: '#1677ff' }}>({activeCompany?.financial_year})</strong>
													) : (
														<span style={{ color: '#888' }}>({company.financial_year})</span>
													)}
												</span>
											</Select.Option>
										))}
									</Select>
								</div>

								<div className="me-1">
									<Link to={routes.oraganizationtree} className="btn btn-menubar btnFullscreen" data-bs-toggle="tooltip"
										data-bs-placement="top"
										title="Organization Structure">
										<i className="ti ti-user"></i>
									</Link>
								</div>
								<div className="me-1">
									<Link to="#" onClick={toggleFullscreen} className="btn btn-menubar btnFullscreen" data-bs-toggle="tooltip"
										data-bs-placement="top"
										title="maximize">
										<i className="ti ti-maximize"></i>
									</Link>
								</div>
								{/* <div className="dropdown me-1">
									<Link to="#" className="btn btn-menubar" data-bs-toggle="dropdown">
										<i className="ti ti-layout-grid-remove"></i>
									</Link>
									<div className="dropdown-menu dropdown-menu-end">
										<div className="card mb-0 border-0 shadow-none">
											<div className="card-header">
												<h4>Applications</h4>
											</div>
											<div className="card-body">
												<Link to={routes.calendar} className="d-block pb-2">
													<span className="avatar avatar-md bg-transparent-dark me-2"><i className="ti ti-calendar text-gray-9"></i></span>Calendar
												</Link>
												<Link to={routes.todo} className="d-block py-2">
													<span className="avatar avatar-md bg-transparent-dark me-2"><i className="ti ti-subtask text-gray-9"></i></span>To Do
												</Link>
												<Link to={routes.notes} className="d-block py-2">
													<span className="avatar avatar-md bg-transparent-dark me-2"><i className="ti ti-notes text-gray-9"></i></span>Notes
												</Link>
												<Link to={routes.fileManager} className="d-block py-2">
													<span className="avatar avatar-md bg-transparent-dark me-2"><i className="ti ti-folder text-gray-9"></i></span>File Manager
												</Link>
												<Link to={routes.kanbanView} className="d-block py-2">
													<span className="avatar avatar-md bg-transparent-dark me-2"><i className="ti ti-layout-kanban text-gray-9"></i></span>Kanban
												</Link>
												<Link to={routes.invoice} className="d-block py-2 pb-0">
													<span className="avatar avatar-md bg-transparent-dark me-2"><i className="ti ti-file-invoice text-gray-9"></i></span>Invoices
												</Link>
											</div>
										</div>
									</div>
								</div> */}
								{/* <div className="me-1">
									<Link to={routes.chat} className="btn btn-menubar position-relative">
										<i className="ti ti-brand-hipchat"></i>
										<span className="badge bg-info rounded-pill d-flex align-items-center justify-content-center header-badge">5</span>
									</Link>
								</div> */}
								{/* <div className="me-1">
									<Link to={routes.email} className="btn btn-menubar">
										<i className="ti ti-mail"></i>
									</Link>
								</div> */}
								<div className="me-1 notification_item">
									<Link to="#" className="btn btn-menubar position-relative me-1" id="notification_popup" data-bs-toggle="dropdown"
										data-bs-placement="top"
										title="Notifications">
										<i className="ti ti-bell"></i>
										{notifications?.data?.length > 0 && (
											<span className="notification-count-badge">
												{notifications?.data?.length}
											</span>
										)}
									</Link>
									<div className="dropdown-menu dropdown-menu-end notification-dropdown p-4">
										<div
											className="d-flex align-items-center justify-content-between border-bottom p-0 pb-3 mb-3">
											<h4 className="notification-title">Notifications ({notifications?.data?.length})</h4>
											{notifications?.data?.length !== 0 &&
												<div className="d-flex align-items-center">
													<Link to="#" className="text-primary fs-15 me-3 lh-1" onClick={handleMarkAllRead}>Mark all as read</Link>
												</div>
											}
										</div>
										<div className="noti-content">
											<div className="d-flex flex-column">
												{notifications?.data?.length === 0 ? (
													<div className="text-center text-muted">No notifications</div>
												) : (
													notifications?.data?.map((notif: any) => (
														<div key={notif.id} className="border-bottom mb-3 pb-3 position-relative">
															<Link to="#">
																<div className="d-flex">
																	<div className="flex-grow-1">
																		<p className="mb-1">
																			<span className="text-dark fw-semibold">{notif.title}</span><br />
																			{notif.message}
																		</p>
																		<span>{new Date(notif.created_at).toLocaleString()}</span>
																	</div>
																</div>
															</Link>
															<p
																className="position-absolute bottom-0 end-0 m-2 text-primary"
																onClick={async () => {
																	await dispatch(
																		markNotificationAsRead({
																			notificationId: notif.notification_id,
																			employeeId: currentEmployeeId,
																		})
																	);

																	// Refetch notifications after marking one as read
																	dispatch(fetchEmployeeNotifications({ employeeId: currentEmployeeId }));
																}}
																style={{ cursor: 'pointer', fontSize: '0.875rem' }}
															>
																Mark as Read
															</p>
														</div>
													))
												)}
											</div>
										</div>
										{/* {notifications?.data?.length !== 0 &&
											<div className="d-flex p-0">
												<Link to="#" className="btn btn-light w-100 me-2">Cancel</Link>
												<Link to={routes.activity} className="btn btn-primary w-100">View All</Link>
											</div>
										} */}
									</div>
								</div>
								<div className="dropdown profile-dropdown">
									<Link to="#" className="dropdown-toggle d-flex align-items-center" data-bs-toggle="dropdown">
										<span className="avatar avatar-sm online">
											{userInformation?.image_path ? (
												<img src={userInformation?.image_path ?? "https://cdn-icons-png.flaticon.com/512/149/149071.png"} alt="Img" className="img-fluid rounded-circle" />
											) : (
												<div className="avatar-text rounded-circle d-flex justify-content-center align-items-center">
													{userInformation?.DisplayName ? userInformation.DisplayName.charAt(0).toUpperCase() : ''}
												</div>
											)}
										</span>
									</Link>
									<div className="dropdown-menu shadow-none">
										<div className="card mb-0">
											<div className="card-header">
												<div className="d-flex align-items-center">
													<span className="avatar avatar-lg me-2 avatar-rounded">
														<img src={userInformation?.image_path ?? "https://cdn-icons-png.flaticon.com/512/149/149071.png"} alt="img" />
														{/* {userInformation?.image_path ? (
															<img src={userInformation.image_path ?? "https://cdn-icons-png.flaticon.com/512/149/149071.png"} alt="img" />
														) : (
															<span className="avatar-text text-bg-danger">
																{userInformation?.DisplayName ? userInformation.DisplayName.charAt(0).toUpperCase() : ''}
															</span>
														)} */}
													</span>
													<div>
														<h5 className="mb-0">{userInformation?.DisplayName}</h5>
														<p className="fs-12 fw-medium mb-0">{user?.Email}</p>
													</div>
												</div>
											</div>
											<div className="card-body">
												<Link className="dropdown-item d-inline-flex align-items-center p-0 py-2" to={routes.profile}>
													<i className="ti ti-user-circle me-1"></i>My Profile
												</Link>
												<Link className="dropdown-item d-inline-flex align-items-center p-0 py-2" to={`${all_routes.employeedetails.replace(":employeeId", btoa(currentEmployeeId?.toString()))}`}>
													<i className="ti ti-eye me-1"></i>Full Details
												</Link>
												<Link className="dropdown-item d-inline-flex align-items-center p-0 py-2" to={routes.companyprofile}>
													<i className="ti ti-building me-1"></i>Company Profile
												</Link>
												{/* <Link className="dropdown-item d-inline-flex align-items-center p-0 py-2" to={routes.bussinessSettings}>
													<i className="ti ti-settings me-1"></i>Settings
												</Link>
												<Link className="dropdown-item d-inline-flex align-items-center p-0 py-2" to={routes.securitysettings}>
													<i className="ti ti-status-change me-1"></i>Status
												</Link> */}

												<div onClick={showModal} className="dropdown-item d-inline-flex align-items-center p-0 py-2" style={{ cursor: 'pointer' }}>
													<i className="ti ti-lock me-1"></i>Update Password
												</div>

												{/* <Link className="dropdown-item d-inline-flex align-items-center p-0 py-2" to={routes.knowledgebase}>
													<i className="ti ti-question-mark me-1"></i>Knowledge Base
												</Link>
												<Link className="dropdown-item d-inline-flex align-items-center p-0 py-2" to={routes.knowledgebase}>
													<i className="ti ti-question-mark me-1"></i>Knowledge Base
												</Link> */}
											</div>
											<div className="card-footer">
												<div className="dropdown-item d-inline-flex align-items-center p-0 py-2" onClick={handleLogout}><i className="ti ti-login me-2"></i>Logout</div>
											</div>
											<ChangePasswordModal visible={isModalVisible} onClose={handleCancel} />
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div className="dropdown mobile-user-menu">
						<Link to="#" className="nav-link dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
							<i className="fa fa-ellipsis-v"></i>
						</Link>
						<div className="dropdown-menu dropdown-menu-end">
							<Link className="dropdown-item" to={routes.profile}>My Profile</Link>
							<Link className="dropdown-item" to={routes.profilesettings}>Settings</Link>
							<Link className="dropdown-item" to={routes.login}>Logout</Link>
						</div>
					</div>

				</div>

			</div>
		</>
	);
};

export default Header;
